import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { refreshToken } from './store/auth/middlewares';
import { BrowserRouter } from "react-router-dom";
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import * as reducer from './store';

import App from './App';
import './index.css';

const middleware = [refreshToken, ...getDefaultMiddleware({
  immutableCheck: false,
  serializableCheck: false,
  thunk: true,
})];

export const store = configureStore({
  reducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js